"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../../index");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const WorkspaceCreateInput_1 = require("./WorkspaceCreateInput");
const graphql_1 = require("../../../graphql");
let WorkspaceUpdateInput = class WorkspaceUpdateInput extends WorkspaceCreateInput_1.WorkspaceCreateInput {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => [String]),
    class_validator_1.IsArray(),
    class_validator_1.IsIn(index_1.INTEGRATION_TYPES, {
        each: true,
    }),
    tslib_1.__metadata("design:type", Array)
], WorkspaceUpdateInput.prototype, "enabledIntegrationClasses", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], WorkspaceUpdateInput.prototype, "archived", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], WorkspaceUpdateInput.prototype, "isUserAnalyticsEnabled", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], WorkspaceUpdateInput.prototype, "isWorkspaceAnalyticsEnabled", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], WorkspaceUpdateInput.prototype, "enableSubscriberTools", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], WorkspaceUpdateInput.prototype, "agreedToTermsOfService", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", String)
], WorkspaceUpdateInput.prototype, "helpLink", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String]),
    class_validator_1.IsArray({
        message: 'Invalid URLs',
    }),
    tslib_1.__metadata("design:type", Array)
], WorkspaceUpdateInput.prototype, "dashboardUrls", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => graphql_1.GraphQLJSON),
    tslib_1.__metadata("design:type", index_1.FeatureFlags)
], WorkspaceUpdateInput.prototype, "featureFlagOverrides", void 0);
WorkspaceUpdateInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], WorkspaceUpdateInput);
exports.WorkspaceUpdateInput = WorkspaceUpdateInput;
//# sourceMappingURL=WorkspaceUpdateInput.js.map